import { Component, PropTypes } from 'react';
import cx from 'classnames';
import styles from './styles.css';

export default class Section extends Component {
	static propTypes = {
		section: PropTypes.shape({
			number: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired
		}).isRequired,
		isActive: PropTypes.bool,
		onClick: PropTypes.func
	}

	render() {
		const { number, title } = this.props.section;
		const className = cx(styles.section, {
			[styles.active]: this.props.isActive
		});

		return (
			<div className={className} onClick={this.props.onClick}>
				<div className={styles.subtitle}>Part {number}</div>
				<div className={styles.title}>{title}</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Section/index.js
 **/